<mat-card style="margin-top: 30px">
  <mat-card-header>
    <h2 mat-card-title><mat-icon>error_outline</mat-icon>Fallout Report</h2>
  </mat-card-header>
  <mat-card-content>
    <!-- Filter Section -->
    <div class="filter-section">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Migration ID</mat-label>
        <input matInput [formControl]="migrationIdControl" placeholder="Enter Migration ID" type="number">
        <mat-icon matSuffix>sync</mat-icon>
      </mat-form-field>

      <div class="filter-actions">
        <button mat-raised-button color="primary" (click)="applyFilters()">
          <mat-icon>search</mat-icon>
          Search
        </button>
        <button mat-raised-button (click)="clearFilters()">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
        <button mat-raised-button (click)="exportToCSV()" [disabled]="allRecords.length === 0">
          <mat-icon>download</mat-icon>
          Export
        </button>
      </div>
    </div>

    <!-- Loading Spinner -->
    @if(isLoading){
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    }

    <!-- Data Table -->
    @if(!isLoading && dataSource.data.length > 0){
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
        <!-- Migration ID Column -->
        <ng-container matColumnDef="migration_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Migration ID</th>
          <td mat-cell *matCellDef="let row">{{ row.migration_id }}</td>
        </ng-container>

        <!-- Company Name Column -->
        <ng-container matColumnDef="company_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
          <td mat-cell *matCellDef="let row">{{ row.company_name || 'N/A' }}</td>
        </ng-container>

        <!-- Protocol ID Column -->
        <ng-container matColumnDef="protocol_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Protocol ID</th>
          <td mat-cell *matCellDef="let row">{{ row.protocol_id || 'N/A' }}</td>
        </ng-container>

        <!-- Sponsor Protocol ID Column -->
        <ng-container matColumnDef="sponsor_protocol_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Sponsor Protocol ID</th>
          <td mat-cell *matCellDef="let row">{{ row.sponsor_protocol_id || 'N/A' }}</td>
        </ng-container>

        <!-- Site ID Column -->
        <ng-container matColumnDef="siteid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Site ID</th>
          <td mat-cell *matCellDef="let row">{{ row.siteid || 'N/A' }}</td>
        </ng-container>

        <!-- Source Entity Column -->
        <!-- <ng-container matColumnDef="source_entity">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Source Entity</th>
          <td mat-cell *matCellDef="let row">{{ row.source_entity }}</td>
        </ng-container> -->

        <!-- Record ID Column -->
        <!-- <ng-container matColumnDef="record_id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Record ID</th>
          <td mat-cell *matCellDef="let row">{{ row.record_id }}</td>
        </ng-container> -->

        <!-- Error Category Column -->
        <ng-container matColumnDef="error_category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Error Category</th>
          <td mat-cell *matCellDef="let row">
            <span [class]="errorBadgeClassMap[row.error_category?.toLowerCase()] || defaultBadgeClass">
              {{ errorCategoryMap[row.error_category?.toLowerCase()] || (row.error_category | uppercase) }}
            </span>
          </td>
        </ng-container>

        <!-- Error Message Column -->
        <ng-container matColumnDef="error_message">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Error Message</th>
          <td mat-cell *matCellDef="let row" class="error-message-cell">
            <span [matTooltip]="row.error_message">{{ row.error_message }}</span>
          </td>
        </ng-container>

        <!-- Created On Column -->
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created On</th>
          <td mat-cell *matCellDef="let row">{{ row.created_at | date: 'MMM d, y, h:mm:ss a' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator
        showFirstLastButtons="true"
        [length]="totalRecords"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="handlePageEvent($event)"
        class="mat-elevation-z8"
      ></mat-paginator>
    </div>
    }

    <!-- Empty State -->
    @if(!isLoading && dataSource.data.length === 0){
    <div class="no-data">
      <mat-icon>info_outline</mat-icon>
      <p>No fallout records found.</p>
    </div>
    }
  </mat-card-content>
  <mat-card-footer>
    *Enter a Migration ID to view detailed fallout records with error messages
  </mat-card-footer>
</mat-card>
